<!-- <div class="header-body border-top-0">
    <div class="header-top header-top-default header-top-borders border-bottom-0 bg-color-light"
        style="min-height: 0px; overflow: visible;">
        <div class="container">
            <div class="header-row">
                <div class="header-column justify-content-end">
                    <div class="header-row">
                      
                        <div class="footer-logo z-index-1">
                            <ul>
                                <li><a href="https://www.facebook.com/ginkonursery" target="_blank"><i
                                            class="bx bxl-facebook"></i></a></li>
                                <li><a href="https://www.instagram.com/ginkonursery/?hl=en" target="_blank"><i
                                            class="bx bxl-instagram"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<nav class="navbar navbar-expand-lg navbar-light navbar-fixed-top start-header">
    <div class="row">
            <div class="col-md-12">
              <div class="d-flex topbar">
                <a href="#" class="d-flex align-items-center">
                  <i class='bx bx-phone-call'></i>
                  <span class="d-none d-md-inline-block"><span class="num">09 42103 7785</span> (Burmese)</span>
                </a>
                <span class="space">|</span>
                 <a href="#" class="d-flex align-items-center">
                  <i class='bx bx-phone-call'></i>
                  <span class="d-none d-md-inline-block"><span class="num">09 42110 7028</span> (Eng)</span>
                </a>
                <span class="space">|</span>

                 <a href="#" class="d-flex align-items-center">
                  <i class='bx bx-home-alt'></i>
                  <span class="d-none d-md-inline-block">No.<span class="num">144</span>, Nay Kyar Street, Pearl 3rd Quarter, Mingaladon Township, Yangon, Myanmar.</span>
                </a>
                <!-- <a href="#" class="d-flex align-items-center">
                  <span class="icon-phone"></span>
                  <span class="d-none d-md-inline-block">+1 234 4567 8910</span>
                </a> -->
              </div>
            </div>
            
          </div>
          <hr/>
    <div class="container-fluid">
        
        <a class="navbar-brand" routerLink="/"><img src="assets/img/logo.png" alt="Logo"></a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse stroke" id="navbarSupportedContent">
            <ul class="navbar-nav">

                <li class="nav-item"><a class="nav-link" (click)="navigate('/')" id="aboutus">ABOUT US</a></li>

                <li class="nav-item"><a class="nav-link" (click)="navigate('services')"
                        [ngClass]="{'active' : routeLink.includes('services')}">SERVICES</a></li>

                <li class="nav-item"><a class="nav-link" (click)="navigate('projects')"
                        [ngClass]="{'active' : routeLink.includes('projects')}">PROJECTS</a></li>

                <li class="nav-item"><a class="nav-link" href="#testimonial"
                        [ngClass]="{'active' : routeLink.includes('#')}">TESTIMONIALS</a></li>

                <li class="nav-item"><a class="nav-link" (click)="navigate('contactus')"
                        [ngClass]="{'active' : routeLink.includes('contactus')}">CONTACT US</a></li>
            </ul>
             <div class="banner-btn">
                <a class="cmn-banner-btn-green" (click)="navigate('contactus')">
                  INQUIRE NOW
                </a>
              </div>
        </div>
    </div>
</nav>

